<template>
  <div id="app">
    <div class="mobile__background"></div>
    <div style="display: none" class="sizePage" :data-number="sizePage"></div>
    <!-- <transition
        name="showAnimat"                         
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
    >-->
    <div class="preloader">
      <img class="preloader__img" src="@/img/logo.png" alt />
      <div class="preloader__line">
        <div class="preloader__line__active"></div>
      </div>
      <div style="position: absolute; opacity: 0" v-for="img in images" :key="img.id">
        <img :src="img.images" alt />
      </div>
    </div>
    <!-- </transition> -->
    <div class="header">
      <transition
          name="showAnimat"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
      >
        <div class="background_menu" v-if="show" @click="show = false"></div>
      </transition>
      <div class="container">
        <div class="header__left">
          <router-link class="header__logo_container" :to="{name: `${langUrl === 'ru' ? footerCopyright.angleUrlUp + 'Ru' : footerCopyright.angleUrlUp + 'En'}`}">
            <img src="@/img/logo.png" alt class="header__logo" />
          </router-link>
          <!-- <a class="header__logo_container" href="/">
            <img src="@/img/logo.png" alt class="header__logo" />
          </a> -->
          <div class="header__select_block">
            <div
              class="header__select"
              @click="showLang = !showLang"
              :class="{ clouse: !showLang }"
            >
              <span class="name_lang">{{languegeAbr}}</span>
              <span class="icon_lang">
                <i class="fas fa-angle-down"></i>
              </span>
            </div>
            <transition
              name="showAnimat"
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <div class="header__select__group" :data-lang="`${lang}`" v-if="showLang">
                <a :href="`/${item.titleBurgerIdCountry.toLowerCase()}/`"
                  v-for="item in langueges"
                  :key="item.index"
                  class="header__select"
                  @click="newLang(item)"
                >{{item.titleBurgerLang}}</a>
              </div>
            </transition>
          </div>
        </div>
        <div class="header__right">
          <div class="header__btn__nav_container">
            <transition
              name="showAnimat"
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <div class="header__btn__nav_block" v-if="show">
                <router-link
                  class="arrow"
                  v-for="(value, index) in burger_name"
                  :key="value.id"
                  :to="{name: `${langUrl === 'ru' ? burger_url[index] + 'Ru' : burger_url[index] + 'En'}`}"
                >
                  <button @click="show = false" class="header__btn__nav">{{value}}</button>
                </router-link>
              </div>
            </transition>
          </div>
          <div class="burger" @click="show = !show" :class="{ open: show }">
            <span class="burger__line"></span>
            <span class="burger__line burger__line--hidden"></span>
            <span class="burger__line"></span>
          </div>
        </div>
      </div>
    </div>
    <div @wheel="wheel">
      <div class="nav_container" style="display: none">
        <div class="nav">
          <router-link
              v-tooltip.left="{content: value, class: 'tooltip-custom'}"
              v-for="(value, index) in burger_name"
              :key="index"
              :to="{name: `${langUrl === 'ru' ? burger_url[index] + 'Ru' : burger_url[index] + 'En'}`}"
          >
            <button class="nav__btn"></button>
          </router-link>
        </div>
      </div>
      <transition :name="animatSlide" mode="out-in">
        <keep-alive>
          <router-view :lang="lang" :sortScreen="sortScreen" :langUrl="langUrl"></router-view>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import {HTTP, Routes, testLoc} from "./API";

export default {
  name: "App",
  data: () => ({
    show: false,
    preload: true,
    showLang: false,
    burger_name: null,
    burger_url: null,
    sizePage: 0,
    footerCopyright: [],
    images: [
      {
        images: require("@/img/Paper/Paper_1_00.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_01.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_02.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_03.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_04.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_05.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_06.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_07.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_08.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_09.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_10.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_11.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_12.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_13.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_14.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_15.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_16.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_17.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_18.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_19.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_20.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_21.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_22.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_23.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_24.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_25.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_26.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_27.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_28.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_29.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_30.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_01.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_02.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_03.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_04.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_05.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_06.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_07.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_08.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_09.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_10.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_11.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_12.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_13.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_14.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_15.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_16.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_17.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_18.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_19.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_20.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_21.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_22.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_23.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_24.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_25.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_26.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_27.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_28.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_29.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_30.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_31.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_32.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_33.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_34.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_35.png"),
      },
      {
        images: require("@/img/Hand/Hand_31_05_36.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_20.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_21.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_22.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_23.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_24.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_25.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_26.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_27.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_28.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_29.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_30.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_31.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_32.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_33.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_34.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_35.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_36.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_37.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_38.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_39.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_40.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_41.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_42.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_43.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_44.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_45.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_46.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_47.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_48.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_49.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_50.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_00.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_01.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_02.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_03.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_04.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_05.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_06.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_07.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_08.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_09.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_10.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_11.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_12.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_13.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_14.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_15.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_16.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_17.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_18.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_19.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_20.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_21.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_22.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_23.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_24.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_25.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_26.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_27.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_28.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_29.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_30.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_31.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_32.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_33.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_34.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_35.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_36.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_37.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_38.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_39.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_40.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_41.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_42.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_43.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_44.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_45.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_46.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_47.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_48.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_49.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_50.png"),
      },
      {
        images: require("@/img/Chocolate_layer_1.png"),
      },
      {
        images: require("@/img/Chocolate_layer_2.png"),
      },
    ],
    animatSlide: "fadeTop",
    test: null,
    lang: null,
    langueges: [],
    languegeAbr: null,
    currentLangueges: null,
    sortScreen: null,
    locationOrigin: window.location,
    langUrl: 'ru',
  }),
  mounted: function () {
    var mql = window.matchMedia("(orientation: portrait)");

    mql.addListener(function (m) {
      if (m.matches) {
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          this.sizePage = window.innerHeight / 568;
          document.querySelector("html").style.fontSize = this.sizePage + "px";
          document.querySelector(".nav_container").style.display = "none";
        } else {
          this.sizePage = window.innerHeight / 900;
          document.querySelector("html").style.fontSize = this.sizePage + "px";
          document.querySelector(".nav_container").style.display = "block";
        }
      } else {
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          this.sizePage = window.innerHeight / 568;
          document.querySelector("html").style.fontSize = this.sizePage + "px";
          document.querySelector(".nav_container").style.display = "none";
        } else {
          this.sizePage = window.innerHeight / 900;
          document.querySelector("html").style.fontSize = this.sizePage + "px";
          document.querySelector(".nav_container").style.display = "block";
        }
      }
    });

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      // console.log('this.$router: ', this.$router);
      // if (localStorage.lang) {
      //   this.langUrl = this.currentLangueges.titleBurgerIdCountry.toLowerCase(); //язык в урл из выбранного языка
      //   console.log('localStorage.langUrl: ', this.langUrl);
      // } else {
      //   this.langUrl = response.data.UrlLng; //язык в урл из гео
      //   console.log('geo.langUrl: ', this.langUrl);
      // }
      //для отображения utm меток
      const search = this.locationOrigin.search
      if(localStorage.lang){
        if(localStorage.lang === 'lang_en'){
          this.langUrl = 'en'
        }
        else{
          this.langUrl = 'ru'
        }
      }else{}
      if(search){
        this.$router.push(`/${this.langUrl}/Mobile/${search}`);
      }else{
        this.$router.push(`/${this.langUrl}/Mobile`);
      }
      document.querySelector(".header").remove();
      document.querySelector("body").classList.add("body_mobile");
      this.sizePage = window.innerHeight / 568;
      document.querySelector("html").style.fontSize = this.sizePage + "px";
      document.querySelector(".nav_container").style.display = "none";
    } else {
      const findIndex = this.$router.history.current.path.split('/').findIndex(item => item === 'Mobile')
      if (findIndex != -1) {
      // if (this.$router.history.current.path === `/${this.langUrl}/Mobile`) {
        this.$router.push(`/`);
        
        // this.$router.push(`/${this.langUrl}`);
      }
      this.sizePage = window.innerHeight / 900;
      document.querySelector("html").style.fontSize = this.sizePage + "px";
      document.querySelector(".nav_container").style.display = "block";
    }


    // запрос данных
    HTTP.get(Routes.testBurger).then((response) => {
      let respons = response.data.UserLng;

      if (localStorage.lang && localStorage.lang === respons) {
        this.lang = localStorage.lang
      } else {
        this.lang = respons
        localStorage.lang = this.lang
      }

      this.burger_name = response.data[this.lang].burger_name.filter(item => item);

      this.test = response;

      this.burger_url = response.data[this.lang].burger_url.filter(item => item);
      this.langueges = response.data[this.lang].burger_lang; //для списка языков
      this.currentLangueges = response.data[this.lang].burger_langTitle; //для выбранного языка
      this.languegeAbr = this.currentLangueges.titleBurgerIdCountry;
      this.sortScreen = response.data[this.lang].sort_screen;

      // для записи языка в урл 
      if (localStorage.lang) {
        this.langUrl = this.currentLangueges.titleBurgerIdCountry.toLowerCase(); //язык в урл из выбранного языка
      } else {
        this.langUrl = response.data.UrlLng; //язык в урл из гео
      }
      const arUrl = this.locationOrigin.pathname.split('/');
      const search = this.locationOrigin.search
      arUrl[1] = `${this.langUrl}`;
      
      const newArUrl = arUrl.join('/');
      const newUrl = window.location.origin + newArUrl + search;

    // для перехода на главную страницу по клику на лого используются данные из футера
      HTTP.get(Routes.footer)
        .then(response => {
            this.footerCopyright = response.data[this.lang].footer.footerCopyright[0]
        })


      HTTP.get(Routes.recipes).then((response) => {
        for (let i = 0; i < response.data[this.lang].recipes.length; i++) {
          this.images.push({
            images: response.data[this.lang].recipes[i].imges,
          });
        }
        HTTP.get(Routes.news).then((response) => {
          for (let i = 0; i < response.data[this.lang].news.length; i++) {
            this.images.push({
              images: response.data[this.lang].news[i].imges,
            });
          }
        
          setTimeout(() => {
            var preloader = document.querySelector(".preloader"), // селектор прелоадера
              imagesCount = document.querySelectorAll("img").length, // количество изображений
              percent = 100 / imagesCount, // количество % на одну картинку
              progress = 0, // точка отсчета
              loadedImg = 0; // счетчик загрузки картинок

            this.widthActive = loadedImg;

            if (imagesCount > 0) {
              for (var i = 0; i < imagesCount; i++) {
                // создаем клоны изображений§
                var img_copy = new Image();
                img_copy.src = document.images[i].src;
                img_copy.onload = img_load;
                img_copy.onerror = img_load;
              }

              function img_load() {
                progress += percent;
                loadedImg++;
                if (progress >= 100 || loadedImg == imagesCount) {
                  document.querySelector(".preloader").remove();
                } else {
                  document.querySelector(".preloader__line__active").style.width =
                    progress + "%";
                }
              }
            } else {
              document.querySelector(".preloader").remove();
            }
          }, 0);
        });
      });
    });
  },
  methods: {
    wheel(ev) {
      if (ev.deltaY > 0) {
        this.animatSlide = "fadeTop";
      }
      if (ev.deltaY < 0) {
        this.animatSlide = "fadeBottom";
      }
    },
    newLang(e) {
      localStorage.lang = e.titleBurgerCountry
    },
  },
};
</script>